// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { LanguageProvider } from "./Component/LanguageProvider";
// import Navbarsection from "./Component/Navbarsection";
// import { HomePage } from "./Pages/HomePage";
// import { AboutUsPage } from "./Pages/AboutUsPage";
// import { FloatingButtons } from "./Component/FloatingButtons";
// import { OurServicesPage } from "./Pages/OurServicesPage";

// import { BlogsPage } from "./Pages/BlogsPage";
// import BlogDetailsPage from "./Pages/BlogDetailsPage";
// import Footer from "./Component/Footer";
// import { Login } from './Component/Auth/Login';
// import DashboardLayout from './Component/Auth/DashboardLayout';
// import Clients from './Component/Auth/Clients';

// function App() {
//   return (
//     <LanguageProvider>
//       <BrowserRouter>
//         <Navbarsection />
//                 <FloatingButtons />

//         <Routes>
//           <Route path="/" element={<HomePage />} />
//           <Route path="/about" element={<AboutUsPage />} />
//           <Route path="/services" element={<OurServicesPage />} />
//           <Route path="/blogs" element={<BlogsPage />} />
//           <Route path="/blog/:id" element={<BlogDetailsPage />} />
//                     <Route path="/Login" element={<Login />} />
//                     <Route path="/admin/dashboard" element={<DashboardLayout />} />
//                     {/* <Route path="/admin/dashboard/clients" element={<Clients />} /> */}

//         </Routes>
//         <Footer />
//       </BrowserRouter>
//     </LanguageProvider>
//   );
// }

// export default App;











import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from "./Component/LanguageProvider";
import Navbarsection from "./Component/Navbarsection";
import { HomePage } from "./Pages/HomePage";
import { AboutUsPage } from "./Pages/AboutUsPage";
import { FloatingButtons } from "./Component/FloatingButtons";
import { OurServicesPage } from "./Pages/OurServicesPage";
import { BlogsPage } from "./Pages/BlogsPage";
import BlogDetailsPage from "./Pages/BlogDetailsPage";
import Footer from "./Component/Footer";
import { Login } from './Component/Auth/Login';
import DashboardLayout from './Component/Auth/DashboardLayout';
import Clients from './Component/Auth/Clients';

// مكون منفصل للتحكم في الـ Navbar
const AppContent = () => {
  const location = useLocation();
  
  // المسارات اللي مش عايز الـ navbar يظهر فيها
  const hideNavbarPaths = ['/Login', '/admin/dashboard', '/admin/dashboard/clients'];
  
  // التحقق إذا كان المسار الحالي من المسارات المخفية
  const shouldHideNavbar = hideNavbarPaths.includes(location.pathname);
  
  return (
    <>
      {/* إخفاء الـ Navbar في المسارات المحددة */}
      {!shouldHideNavbar && <Navbarsection />}
      
      <FloatingButtons />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/services" element={<OurServicesPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog/:id" element={<BlogDetailsPage />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/admin/dashboard" element={<DashboardLayout />} />
        {/* <Route path="/admin/dashboard/clients" element={<Clients />} /> */}
      </Routes>
      
      {/* إخفاء الـ Footer كمان في نفس المسارات */}
      {!shouldHideNavbar && <Footer />}
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;





